/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');

      
        this.createSlider($sliderEl);

    },
    createSlider: function ($sliderEl) {

      const slideData = {
        products_per_slide: 1,
        products_available: 1,
        products_limit: 1,
      }

      const slider = $sliderEl.flickity({
        lazyLoad: 2,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'left',
        autoPlay: true,
        autoPlay: 3000,
        wrapAround: true,
        pageDots: false,
        contain: true,
        prevNextButtons: true,
        initialIndex: 0,
        arrowShape: arrowShape
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;